import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Loader2, ShieldCheck, AlertCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const error = location.state?.error;

  useEffect(() => {
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then(() => navigate('/admin', { replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-black text-gold flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
      <Card className="bg-white/5 border-gold/30 w-full max-w-md" data-testid="admin-login-card">
        <CardContent className="p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center">
              <ShieldCheck className="w-8 h-8 text-gold" />
            </div>
          </div>
          <h1 className="text-2xl font-bold mb-2">OLD2NEW Admin</h1>
          <p className="text-white/60 mb-8">Sign in to view quote requests and manage your gallery.</p>

          {error && (
            <div
              data-testid="admin-login-error"
              className="flex items-start gap-2 text-left bg-red-500/10 border border-red-500/30 text-red-300 rounded-md p-3 mb-6 text-sm"
            >
              <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
          )}

          <Button
            data-testid="google-signin-button"
            onClick={handleLogin}
            size="lg"
            className="w-full bg-gold text-black hover:bg-gold/90 font-semibold"
          >
            Sign in with Google
          </Button>

          <button
            onClick={() => navigate('/')}
            className="mt-6 text-white/40 hover:text-gold text-sm transition-colors"
            data-testid="back-to-site-link"
          >
            ← Back to website
          </button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
